import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-white py-6 transition-colors duration-300">
      <div className="max-w-screen-xl mx-auto text-center">
        <p className="text-sm">&copy; All rights reserved. Designed and Created by GRB.</p>
        <div className="mt-4">
          <a href="/contact" className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white mx-3 transition-colors duration-200">
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
